import { QuestionBase } from './question-base';
import { SelectOption } from './question-select-option';

export class SelectQuestion extends QuestionBase<string> {
  controlType = 'select';
  type: string;
  options: SelectOption[];
  selected?: SelectOption;

  constructor(options: {} = {}, items: SelectOption[]) {
    super(options);
    this.type = options['type'] || '';
    this.options = items;
    this.selected = items.find(option => option.selected);
    if (this.selected === undefined) {
      this.selected = new SelectOption('', '');
    }
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/dynamic-form/shared/question-select.ts